import { render } from "./EnvelopeCheckSvg.vue?vue&type=template&id=bb2d91fc"
import script from "./EnvelopeCheckSvg.vue?vue&type=script&lang=js"
export * from "./EnvelopeCheckSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__